import { getCurrentJwt } from "../../../../util/jwt/decryptToken"

export async function fetchCounts(body, signal) {
  // Configure Input Params
  let options = {
    method: "PUT",
    signal: signal,
    headers: {
      Authorization: getCurrentJwt()
    },
    body: JSON.stringify(body)
  }

  let resp_info = await startQuery(options)
  if(!resp_info) {
    return null
  }
  options.method = "POST"
  options.body = resp_info.query_id
  let resp_info2 = await fetchQueryResults(options)
  if(!resp_info2) {
    return null
  }
  return {...resp_info, ...resp_info2}
}

async function startQuery(options) {
  let sleepTime = 500
  let res = null
  const initalTime = Date.now()
  const currTimeout = 900000 // 15 Minutes
  const testAbort = new RegExp(".*AbortError: signal is aborted without reason.*")
  const testAbort2 = new RegExp(".*aborted.*")

  while ((Date.now() - initalTime) < currTimeout) {
    try {
      // Fetch Data
      res = await fetch(process.env.REACT_APP_API + "/audience-builder/query-location-data", options)

      // Handle Auth Error
      if (res.status === 401) {
        window.location = '/login'
      }
      // Handle Valid Request
      else if (res.status === 200) {
        return await res.json()
      }
      // Handle Query Error
      else if(res.status === 500) {
        alert((await res.json()).errorMsg)
        return null
      }
      // Sleep if otherwise
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
    catch (e) {
      // Handle Abort
      if (testAbort.test(e.toString()) || testAbort2.test(e.toString())) {
        return null
      }
      console.log(e)
      // Sleep if Other Error
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }
}

async function fetchQueryResults(options) {
  let sleepTime = 500
  let res = null
  const initalTime = Date.now()
  const currTimeout = 900000 // 15 Minutes
  const testAbort = new RegExp(".*AbortError: signal is aborted without reason.*")
  const testAbort2 = new RegExp(".*aborted.*")

  while ((Date.now() - initalTime) < currTimeout) {
    try {
      // Fetch Data
      res = await fetch(process.env.REACT_APP_API + "/audience-builder/query-location-data", options)

      // Handle Auth Error
      if (res.status === 401) {
        window.location = '/login'
      }
      // Handle Valid Request
      else if (res.status === 200) {
        return await res.json()
      }
      // Handle Query Error
      else if(res.status === 500) {
        alert((await res.json()).errorMsg)
        return null
      }
      // Sleep if otherwise
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
    catch (e) {
      // Handle Abort
      if (testAbort.test(e.toString()) || testAbort2.test(e.toString())) {
        return null
      }
      console.log(e)
      // Sleep if Other Error
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }

  return null
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/dataFetches/fetchCounts.js